import { Link } from 'react-router-dom'
import EstadoBadge from './EstadoBadge'
import { fmtFechaHora, fmtMonto } from '../utils/fecha'
import { colors, font } from '../design/tokens'

// Medio de pago del pedido web, como lo eligió el cliente en el checkout.
const MEDIOS = { mobbex: 'Mobbex', mercadopago: 'Mercado Pago', transferencia: 'Transferencia', convenir: 'A convenir', giftcard: 'Gift card' }

/**
 * Pedido repetido en 72 h (Martin, 29 oct 2026): el mismo cliente —por email,
 * teléfono, nombre o IP— tiene otra NV 72 h antes (esta la repite) o después
 * (volvió a pedir). Solo avisa, y solo si alguna de las dos ya tiene remito
 * impreso (sin papel puede ser un reintento de pago). Dice cuál lo tiene. La
 * regla vive en PedidoRepetidoService.
 */
export default function AvisoPedidoRepetido({ repetidos }) {
  const { anteriores = [], posteriores = [], remito_impreso: propio } = repetidos || {}
  if (anteriores.length === 0 && posteriores.length === 0) return null

  return (
    <div style={st.caja}>
      {propio && <div style={{ marginBottom: 6 }}>Esta NV ya tiene remito impreso: <b>{propio}</b></div>}
      {anteriores.length > 0 && (
        <Bloque titulo="🔁 Pedido repetido: el mismo cliente hizo otro pedido en las 72 h anteriores" filas={anteriores} cuando="antes" />
      )}
      {posteriores.length > 0 && (
        <Bloque titulo="🔁 Este cliente volvió a pedir dentro de las 72 h siguientes" filas={posteriores} cuando="después" separado={anteriores.length > 0} />
      )}
    </div>
  )
}

function Bloque({ titulo, filas, cuando, separado }) {
  return (
    <div style={separado ? { marginTop: 10, paddingTop: 10, borderTop: `1px dashed ${colors.warnStrong}` } : null}>
      <div style={{ fontWeight: 600, marginBottom: 6 }}>{titulo}</div>
      {filas.map(f => (
        <div key={f.id} style={{ marginTop: 6 }}>
          <div style={st.linea}>
            <Link to={`/notas-venta/${f.id}`} style={st.link}>{f.numero_lgr || `NV #${f.id}`}</Link>
            <span>{f.pedido ? `pedido ${f.pedido} · ` : ''}{fmtFechaHora(f.creada_at)} ({f.horas} h {cuando})</span>
            {f.total > 0 && <span>$ {fmtMonto(f.total)}{f.medio ? ` · ${MEDIOS[f.medio] || f.medio}` : ''}</span>}
            <EstadoBadge estado={f.estado} />
            {f.archivado && <span style={st.marca}>Archivada</span>}
            {f.fraude && <span style={{ ...st.marca, color: colors.err, background: colors.errBg }}>Fraude</span>}
          </div>
          <div style={{ marginTop: 2 }}>Coincide: <b>{f.coincide.join(' · ')}</b></div>
          <div style={{ marginTop: 2 }}>
            {f.remito_impreso ? <>Remito impreso: <b>{f.remito_impreso}</b></> : 'Sin remito impreso'}
          </div>
        </div>
      ))}
    </div>
  )
}

const st = {
  caja: { margin: '0 0 1rem', padding: '12px 16px', background: colors.warnBg, border: `1px solid ${colors.warnStrong}`, borderRadius: 8, color: colors.warn, fontSize: '0.9rem' },
  linea: { display: 'flex', flexWrap: 'wrap', gap: '4px 16px', alignItems: 'center' },
  link: { color: colors.link, fontWeight: 600, fontFamily: font.mono },
  marca: { fontSize: '0.75rem', fontWeight: 600, padding: '1px 8px', borderRadius: 999, background: colors.borderSoft, color: colors.textSec },
}
